// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e83e729","455":"51615914","977":"f1a95607"}[chunkId] + ".chunk.js";
};